export default __webpack_public_path__ + "static/media/profile.aa253206.png";